<template>
  <div class="panel panel-default">
    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body">
      <div class="row tw-mb-6">
        <div class="col-xs-offset-12 col-xs-6">
          <SelectWidget
              v-model="location"
              :options="locationOptions"
              :nullable="true"
              placeholder="(all locations)"
          />
        </div>

        <div class="col-xs-6">
          <SelectWidget
              v-model="format"
              :options="formatOptions"
              :nullable="true"
              placeholder="(all formats)"
          />
        </div>
      </div>

      <table class="capacity">
        <thead>
        <tr>
          <td class="capacity__first-cell"></td>

          <td v-for="headline in headlines" :key="headline.id" colspan="7" class="capacity__head-cell">
            <span class="capacity__head-inner-cell">
              <div class="capacity__headline">
                {{ headline | date }} (week {{ headline | week }})
              </div>
            </span>
          </td>
        </tr>
        </thead>

        <tbody v-if="filteredRows.length">
        <tr v-for="row in filteredRows" :key="row.id" is="time-capacity-row" :row="row" :date="date"></tr>
        </tbody>

        <tbody v-else>
        <tr>
          <td class="text-center" colspan="29">
            <i>
              There are no ads to display.
            </i>
          </td>
        </tr>
        </tbody>
      </table>

      <pager :date="date" @navigate="date = $event"></pager>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Load from '@/mixins/Load'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import Pager from '@/components/Panels/Publications/TimeBasedChannelCapacityPanel/Pager'
import SaveHeight from '@/mixins/SaveHeight'
import TimeCapacityRow from '@/components/Panels/Publications/TimeBasedChannelCapacityPanel/TimeCapacityRow'
import SelectWidget from "../../../../vendor/forms/FormGroups/Widgets/Select";

export default {
  components: {LoadingSpinner, Pager, SelectWidget, TimeCapacityRow},

  mixins: [Load, SaveHeight],

  props: ['channelId', 'channelType'],

  data() {
    return {
      capacity: null,
      date: moment(this.getQueryParam('date', moment())).startOf('isoWeek').format('YYYY-MM-DD'),

      location: null,
      format: null
    }
  },

  watch: {
    channelId() {
      this.fetch()
    },

    date(value) {
      this.fetch()

      this.$router.push(
          '/capacity?channel-id=' + this.channelId + '&channel-type=' + this.channelType + '&date=' + value
      )
    }
  },

  mounted() {
    this.fetch()
  },

  computed: {
    headlines() {
      return [
        moment(this.date).format('YYYY-MM-DD'),
        moment(this.date).add(7, 'days').format('YYYY-MM-DD'),
        moment(this.date).add(14, 'days').format('YYYY-MM-DD'),
        moment(this.date).add(21, 'days').format('YYYY-MM-DD')
      ]
    },

    end() {
      return moment(this.date).add(27, 'days').format('YYYY-MM-DD')
    },

    filteredRows() {
      return this.capacity.data.rows
          .filter(row => !this.location || row.time_based_ad_location.id.toString() === this.location)
          .filter(row => !this.format || row.time_based_ad_format.id.toString() === this.format)
    },

    locationOptions() {
      return Object.entries(this.capacity.data.rows.reduce((result, row) => {
        result[row.time_based_ad_location.id] = row.time_based_ad_location.name

        return result
      }, {})).map(entry => ({value: entry[0], label: entry[1]}))
    },

    formatOptions() {
      return Object.entries(this.capacity.data.rows.reduce((result, row) => {
        result[row.time_based_ad_format.id] = row.time_based_ad_format.name

        return result
      }, {})).map(entry => ({value: entry[0], label: entry[1]}))
    }
  },

  methods: {
    fetch() {
      this.saveHeight()

      this.load({
        capacity: '/api/v1/time-based-channels/' + this.channelId + '/capacity?starts_at=' + this.date + '&ends_at=' + this.end
      })
    },

    getQueryParam(key, defaultValue = null) {
      return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
    }
  }
}
</script>
